/**
 * Hestiahome — colour dots on the brand product card (snippets/card-product-hestia.liquid).
 *
 * Hovering or clicking a dot swaps the card's primary image to that colour's variant
 * photo with a short cross-fade, and moves the active ring onto the dot. (Keyboard focus
 * draws the ring from CSS alone; the swap needs the click.)
 *
 * WHY IT IS DELEGATED ON `document`: the card is rendered on three surfaces
 * (sections/collection-grid, related-products, cross-sell) and on two of them the cards
 * arrive AFTER page load — the collection grid re-renders on every facet change, and
 * <product-recommendations> fetches its cards over AJAX. A listener bound to the cards
 * themselves, or to a section root that is itself replaced, would go dead on the first
 * refresh. One pair of listeners on `document` covers every card, now and later.
 *
 * This lived inline in sections/collection-grid.liquid until the product page's
 * recommended row shipped without it — the dots rendered but did nothing there. Shared
 * asset so a fourth surface cannot repeat that.
 */
(function () {
  if (window.hestiaCardSwatchesReady) return;
  window.hestiaCardSwatchesReady = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function swap(btn) {
    var media = btn.getAttribute('data-hestia-media');
    if (!media) return;
    var card = btn.closest('.card--hestia');
    if (!card) return;
    var img = card.querySelector('[data-hestia-primary]');
    if (!img) return;

    var group = btn.closest('[data-hestia-swatches]');
    if (group) {
      var swatches = group.querySelectorAll('.card-hestia__swatch');
      for (var i = 0; i < swatches.length; i++) swatches[i].classList.remove('is-active');
    }
    btn.classList.add('is-active');

    if (reduce) {
      img.removeAttribute('srcset');
      img.src = media;
      return;
    }

    img.style.opacity = '0';
    var reveal = function () {
      img.style.opacity = '1';
    };
    img.addEventListener('load', reveal, { once: true });
    window.requestAnimationFrame(function () {
      img.removeAttribute('srcset');
      img.src = media;
      if (img.complete) reveal();
    });
  }

  // `e.target` is not always an Element at document level (it can be `document` itself),
  // and only Elements carry .closest — hence the guard the old section-root version could
  // do without.
  function swatchFrom(e) {
    var target = e.target;
    if (!target || typeof target.closest !== 'function') return null;
    return target.closest('[data-hestia-swatch]');
  }

  document.addEventListener('click', function (e) {
    var btn = swatchFrom(e);
    if (!btn) return;
    e.preventDefault();
    swap(btn);
  });

  document.addEventListener(
    'mouseover',
    function (e) {
      var btn = swatchFrom(e);
      if (btn) swap(btn);
    },
    { passive: true }
  );
})();
